import axios from 'axios';
import { ErrorType, recordError } from '../models/apiWrappers/api/exceptions';

interface IpapiResponse {
  city: string;
  country: string;
  ip: string;
  loc: string;
  org: string;
  readme: string;
  region: string;
  timezone: string;
}

export const getIpInfo = async (): Promise<IpapiResponse | { error: unknown }> => {
  try {
    const response = await axios.get('https://ipinfo.io/json');
    return response.data as IpapiResponse;
  } catch (err) {
    recordError(ErrorType.API, '[getIpInfo API] error', { err });
    return { error: err };
  }
};
